import createVueComponent from '../createVueComponent';

const Divide = createVueComponent('DivideIcon', [
  ['circle', { cx: '12', cy: '6', r: '1', key: '1bh7o1' }],
  ['line', { x1: '5', x2: '19', y1: '12', y2: '12', key: '13b5wn' }],
  ['circle', { cx: '12', cy: '18', r: '1', key: 'lqb9t5' }],
]);

export default Divide;
